var _style, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIndustrial(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 480 480",
    style: {
      enableBackground: "new 0 0 480 480"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M9.2,0C4.1,0,0,4.1,0,9.2v461.5c0,5.1,4.1,9.2,9.2,9.2h461.5c5.1,0,9.2-4.1,9.2-9.2V141.1c0-3.3-1.8-6.4-4.7-8 c-2.9-1.6-6.4-1.6-9.3,0.1l-150.9,90.5v-82.6c0-3.3-1.8-6.4-4.7-8c-2.9-1.6-6.4-1.6-9.3,0.1l-150.9,90.5V9.2c0-5.1-4.1-9.2-9.2-9.2 H9.2z M18.5,67.7V18.5h113.4v49.2H18.5z M18.5,86.2v375.4h443.1V157.4l-150.9,90.5c-2.9,1.7-6.4,1.8-9.3,0.1c-2.9-1.6-4.7-4.7-4.7-8 v-82.6l-150.9,90.5c-2.9,1.7-6.4,1.8-9.3,0.1c-2.9-1.6-4.7-4.7-4.7-8V86.2H18.5z M102.6,316.9c0-5.1,4.1-9.2,9.2-9.2h76.9 c5.1,0,9.2,4.1,9.2,9.2v76.9c0,5.1-4.1,9.2-9.2,9.2h-76.9c-5.1,0-9.2-4.1-9.2-9.2V316.9z M121,326.2v58.5h58.5v-58.5H121z  M316.9,307.7c-5.1,0-9.2,4.1-9.2,9.2v76.9c0,5.1,4.1,9.2,9.2,9.2h76.9c5.1,0,9.2-4.1,9.2-9.2v-76.9c0-5.1-4.1-9.2-9.2-9.2H316.9z  M326.2,384.6v-58.5h58.5v58.5H326.2z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndustrial);
export default __webpack_public_path__ + "static/media/industrial.e154f73e.svg";
export { ForwardRef as ReactComponent };